import axios from "axios";

export async function getDistanceFromTmap({ startLat, startLng, endLat, endLng }) {
  const res = await axios({
    method: "POST",
    url: "https://apis.openapi.sk.com/tmap/routes?version=1&appKey=BdlYOwdogG90lbnPuqHhT1wydn8ZAjTj9IisO2CV",
    data: {
      startY: startLat,
      startX: startLng,
      endY: endLat,
      endX: endLng,
      reqCoordType: "WGS84GEO",
      resCoordType: "WGS84GEO",
      tollgateFareInfo: "Y",
    },
  });

  const { totalDistance, totalTime, totalFare } = res.data.features[0].properties;

  return {
    totalDistance: parseFloat((totalDistance / 1000).toFixed(1)),
    totalTime: parseInt((totalTime / 60).toFixed(0)),
    totalFare: totalFare,
  };
}

export const parseDriverInfoFromClipboard = (text) => {
  let _from = "";
  let _driverName = "";
  let _driverPhoneNumber = "";
  let _driverCarInfo = "";
  let _driverCarNumber = "";

  const lines = text.split("\n");

  // *24시콜 모바일
  //경남 사천 -> 경남 김해
  // [차주정보] 박명석 / 01028685644
  // [차량정보] 플축카고 / 5톤 / 경남80사5626
  // if text line has 3 lines, then it is 24시콜 모바일
  if (lines.length === 3) {
    _from = "24시콜 모바일";
    const driverMatch = text.match(/차주정보\] (.+) \/ (.+)/);
    const carMatch = text.match(/차량정보\] (.+) \/ (.+) \/ (.+)/);

    if (driverMatch) {
      _driverName = driverMatch[1];
      _driverPhoneNumber = driverMatch[2];
    }

    if (carMatch) {
      _driverCarInfo = `${carMatch[2]} ${carMatch[1]}`;
      _driverCarNumber = carMatch[3];
    }
  }

  // *화물맨 모바일
  // [차주정보 공유]
  // 박재환
  // 경남80사9023 / 카고 / 25톤
  // 010-9393-8538
  // 경남 함안군 군북면 → 경남 사천시 사남면
  if (lines.length === 5) {
    _from = "화물맨 모바일";
    _driverName = lines[1].trim();
    _driverPhoneNumber = lines[3].trim();

    const carInfo = lines[2].split(" / ");
    if (carInfo.length === 3) {
      _driverCarNumber = carInfo[0];
      _driverCarInfo = `${carInfo[2]} ${carInfo[1]}`;
    }
  }

  // *원콜모마일
  // 상차지 : 울산북구 중산동
  // 하차지 : 인천남동구 고잔동
  // 상차일시 : 01-10 11:00
  // 하차일시 : 01-10
  // 기사명 : 박태영
  // 기사전화 : 01074379001
  // 차량번호 : 경기96사1229
  // 차종  : 윙바디1T
  if (lines.length === 8 && text.includes("상차지")) {
    _from = "원콜 모바일";
    _driverName = text.match(/기사명 : (.+)/)?.[1] || "";
    _driverPhoneNumber = text.match(/기사전화 : (.+)/)?.[1] || "";
    _driverCarNumber = text.match(/차량번호 : (.+)/)?.[1] || "";
    _driverCarInfo = text.match(/차종 {2}: (.+)/)?.[1] || "";
  }

  // *24시콜 PC
  // 안창도 부산94아3704 010-2279-1917
  if (lines.length === 1 && !text.includes(",")) {
    _from = "24시콜 PC";
    const parts = text.trim().split(" ");
    if (parts.length === 3) {
      _driverName = parts[0];
      _driverCarNumber = parts[1];
      _driverPhoneNumber = parts[2];
    }
  }

  // *화물맨 PC
  // 박재환,010-9393-8538,경남80사9023
  if (lines.length === 1 && text.includes(",")) {
    _from = "화물맨 PC";
    const parts = text.split(",");
    if (parts.length === 3) {
      _driverName = parts[0];
      _driverPhoneNumber = parts[1];
      _driverCarNumber = parts[2];
    }
  }

  return {
    from: _from,
    driverName: _driverName,
    driverPhoneNumber: _driverPhoneNumber,
    driverCarInfo: _driverCarInfo,
    driverCarNumber: _driverCarNumber,
  };
};
